
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/betting-results",
      function () {
        return require("private-next-pages/[league]/betting-results/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/betting-results"])
      });
    }
  